import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Headerfour";
import Breadcrumb from "../layouts/Breadcrumb";
import Footer from "../layouts/Footerthree";
import Content from "../sections/services/Content";
import FinancailContent from "../sections/services/FinancailContent";
import { useTranslation } from "react-i18next";

const Planing = () => {
  const {t} = useTranslation();

  return (
    <Fragment>
      <Helmet>
        <title>Buy Home For Less | Financial Planing</title>
        <meta name="description" content="#" />
      </Helmet>
      <Header />
      <Breadcrumb breadcrumb={{ pagename: t("Financial Planing") }} />
      <FinancailContent />
      <Footer />
    </Fragment>
  );
};

export default Planing;
